export const SecurityCapability = `SecurityCapability`;
export const DocCategory = `DocCategory`;
export const FiscalPeriod = `FiscalPeriod`;
export const FiscalYear = `FiscalYear`;
export const ReportDefinition = `ReportDefinition`;
export const ApprovalDefinition = `ApprovalDefinition`;
export const DMSDocument = "DMSDocument";
export const DMSFolder = "DMSFolder";
export const Remark = "Remark";
export const RemarkType = "RemarkType";
export const DetailedRemark = "DetailedRemark";
export const Account = "Account";
export const AccountsChart = "AccountsChart";
export const AUTestDef = "AUTestDef";
export const AUPhase = "AUPhase";
export const CriteriaDefinition = "CriteriaDefinition";
export const DashBoard = "DashBoard";
export const ReportGroup = "ReportGroup";
export const DashBoardGroup = "DashBoardGroup";
export const Currency = "Currency";